<template>
  <div>
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>我的云店</BreadcrumbItem>
          <BreadcrumbItem>产品展示组</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.name}}</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="$router.push('/exhibition/index/proGroup/productadd')">
          <span class="htb-add">+</span>
          <span>添加展示组</span>
        </div>
      </div>
    </div>
    <div class="my-item">
      <div class="custom-wrap">
        <template v-if="list && list.items && list.items.length">
          <Table :border="false" :columns="columns1" :data="list.items" :disabled-hover="false">
            <template slot-scope="{ row, index }" slot="groupName">{{row.name}}</template>
            <template slot-scope="{ row, index }" slot="time">{{row.inTime | moment("YYYY/MM/DD")}}</template>
            <template slot-scope="{ row, index }" slot="action">
              <span style="color: #1890ff;cursor: pointer;" @click="view(row)">产品</span>
              <span style="display: inline-block;padding: 0 5px;">|</span>
              <span style="color: #1890ff;cursor: pointer;" @click="edit(row)">编辑</span>
              <span style="display: inline-block;padding: 0 5px;">|</span>
              <Poptip confirm title="确认是否删除?" @on-ok="delItem(row)" :transfer="true">
                <span style="color: #f00;cursor: pointer;">删除</span>
              </Poptip>
            </template>
          </Table>
          <div class="my-page" v-if="totalCount > pageSize">
            <Page
              show-total
              show-elevator
              :page-size="pageSize"
              :current="pageIndex"
              :total="totalCount"
              @on-change="changePage"
              @on-page-size-change="changePageSize"
            />
          </div>
        </template>
        <div class="u-empty" v-else>暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  // 顶部banner
  name: "photo-top",
  data() {
    return {
      add: false,
      list: null,
      pageSize: 16,
      pageIndex: 1,
      totalCount: 0,
      viewFlag: false,
      editShow: false,
      editInfo: null,
      loading: false,

      columns1: [
        {
          title: "展示组名称",
          slot: "groupName",
          key: "groupName",
          align: "center"
        },
        {
          title: "创建时间",
          slot: "time",
          key: "time",
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          align: "center"
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition"
    }),
    option() {
      return { compId: this.company.id };
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getProductGroup: "productModule/getProductGroup",
      delProductGroup: "productModule/delProductGroup",
      editProductGroup: "productModule/editProductGroup"
    }),
    handleView(data) {
      this.viewFlag = true;
    },
    async delItem(item) {
      let result = await this.delProductGroup(item.id);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
    async init() {
      let listData = await this.getProductGroup(this.option);

      if (listData && listData.items) {
        listData.items.forEach(c => {
          try {
            c.introduction = JSON.parse(c.introduction);
          } catch (error) {
            c.introduction = {};
          }
        });
        this.list = listData;
        this.pageSize = this.list.pageSize;
        this.pageIndex = this.list.pageIndex;
        this.totalCount = this.list.totalCount;
      }
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
    },
    changeSwitch(e, data) {
      this.edit(data);
    },
    edit(item) {
      this.$router.push(`/exhibition/index/proGroup/productedit?id=${item.id}`);
    },
    view(item) {
      this.$router.push(`/exhibition/index/proGroup/productproList?id=${item.id}&name=${item.name}`);
    }
  }
};
</script>

<style scoped lang="scss">
.custom-wrap {
  margin: 0 auto;
  min-height: 500px;
}
</style>
